import { createFileRoute } from '@tanstack/react-router'
import { BoxesIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/assortment')({
  staticData: {
    title: 'route.assortment',
    crumb: 'route.assortment',
    icon: BoxesIcon,
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
